
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../mixins";
import {
  ISingleSelectableAsynchronously,
} from "..";

@Component
export default class DialogSelectableMixin extends Mixins(ModelEditableMixin) {
  @Prop()
  dialog: ISingleSelectableAsynchronously<any>;

  @Prop({ default: true })
  isEnable: boolean;

  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: "選択" })
  labelOfSelect: string;

  @Prop({ default: "クリア" })
  labelOfClear: string;

  @Prop()
  format: (s: any) => string;

  @Prop()
  condition: any;

  get labelOfSelectedOption(): string {
    return !this.format
      ? (!this.editingSource ? "" : this.editingSource.toString())
      : this.format(this.editingSource);
  }

  get isSelectable(): boolean {
    return this.isEnable
      && !!this.dialog;
  }

  select(): void {
    this.selectOption()
      .then(o => {
        if (o !== undefined) {  // undefinedの時はキャンセル.
          this.editingSource = o;
        }
      });
  }

  async selectOption(): Promise<any> {
    // TODO: 本Mixin実装はDialogSelectorで動作してた実装を抽出したが、下記コードがあるとなぜかMixinのマージ時にVue.jsがエラーを出してしまう.
    // Uncaught TypeError: Cannot read property 'components' of undefined
    // Vue.jsのバグじゃないかと思われるが、どうにもならないので暫定対処で回避.(anyにcastして同様の判定を実装する.)
//    if (instanceOfISingleSelectableConditionallyAsynchronously<any, any>(this.dialog)) {
//      return this.dialog.selectOptionConditionally(this.condition, this.editingSource);
    const dialogAsAny = this.dialog as any;
    if (dialogAsAny && dialogAsAny.selectOptionConditionally) {
      return dialogAsAny.selectOptionConditionally(this.condition, this.editingSource);
    } else {
      return this.dialog.selectOption(this.editingSource);
    }
  }

  clear(): void {
    this.editingSource = null;
  }
}
